export const PaymentFailedView = () => {
    return (
        <div>
            <h1>Payment Failed</h1>
        </div>
    );
};